import { CustomField } from "../types/custom-fields/custom-field"
import { CustomFieldDefinition } from "../types/custom-fields/custom-field-definition"
import { ModuleField } from "../types/custom-fields/module-field"

/**
 * Builds the module fields from the field definitions (from the contract), if any.
 * The list of fields are retrieved from backend and then filtered by the field definitions contained in the contract.
 * The result is a list of module fields with the configuration, merged together.
 * @param fieldDefinitions The definition of the custom fields in the contract.
 * @param fields The list of custom fields retrieved from the backend.
 * @returns The complete merged module fields and the fields configuration of the FSM, if any.
 */
export async function buildModuleFields(fieldDefinitions: CustomFieldDefinition[], fields: CustomField[]): Promise<ModuleField[]> {
  const result: ModuleField[] = []
  fieldDefinitions.forEach((field) => {
    const customField = fields.find((cf) => cf._id === field._id)
    if (customField) {
      result.push({
        ...customField,
        label: field.labelTextOverride ?? customField.label,
        required: field.required ?? false
      })
    }
  })
  return result
}
